import { useSearchParams } from '../../../hooks';
import { weekParamString } from '../../../config/queryParams';
export var useWeekQueryParam = function (maxWeekNumber) {
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var weekParam = Number(searchParams.get(weekParamString)) || 1;
    var setWeekParam = function (weekNumber) {
        var _a;
        return setSearchParams((_a = {}, _a[weekParamString] = weekNumber.toString(), _a));
    };
    return {
        weekParam: Math.min(weekParam, maxWeekNumber),
        setWeekParam: setWeekParam
    };
};
